import CheeseProduct from 'models/CheeseProduct'

export const packagingInitialState = {
  category: CheeseProduct.category,
  subCategory: CheeseProduct.subCategory,
  FatLevel: {
    value: '',
    label: 'Fat Level',
  },
  Type: {
    value: '',
    label: 'Type',
  },
  Size: {
    value: '',
    label: 'Size',
  },
  MadeInUSA: false,
  Kosher: false,
}

export const fatLevelOptions = [
  {
    value: '',
    label: 'Fat Level',
    isDisabled: true,
  },
  {
    value: 'Regular',
    label: 'Regular',
  },
  { value: 'Lowfat', label: 'Lowfat' },
  { value: 'Fat Free', label: 'Fat Free' },
]

export const cheeseTypeOptions = [
  {
    value: '',
    label: 'Type',
    isDisabled: true,
  },
  {
    value: 'Cheddar - Orange - Mild',
    label: 'Cheddar - Orange - Mild',
  },
  {
    value: 'Cheddar - Orange - Medium',
    label: 'Cheddar - Orange - Medium',
  },
  {
    value: 'Cheddar - Orange - Sharp',
    label: 'Cheddar - Orange - Sharp',
  },
  {
    value: 'Cheddar - Orange - Longhorn',
    label: 'Cheddar - Orange - Longhorn',
  },
  {
    value: 'Cheddar - White - Mild',
    label: 'Cheddar - White - Mild',
  },
  {
    value: 'Cheddar - White - Medium',
    label: 'Cheddar - White - Medium',
  },
  {
    value: 'Cheddar - White - Sharp',
    label: 'Cheddar - White - Sharp',
  },
  {
    value: 'Cheddar - White - Longhorn',
    label: 'Cheddar - White - Longhorn',
  },
  {
    value: 'Colby',
    label: 'Colby',
  },
  {
    value: 'Jack',
    label: 'Jack',
  },
  {
    value: 'Marbled or Blend of Authorized Cheese',
    label: 'Marbled or Blend of Authorized Cheese',
  },
  {
    value: 'Mozzarella',
    label: 'Mozzarella',
  },
  {
    value: 'Mozzarella String - Individually wrapped sticks',
    label: 'Mozzarella String - Individually wrapped sticks',
  },
]

export const sizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  {
    value: '16 oz',
    label: '16 oz',
  },
  { value: '32 oz', label: '32 oz' },
]
